import React, { useState, useEffect, useCallback } from "react";
import { Breadcrumb, Container, Row, Col, Button } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import { useAcubeService } from "../../service/acube-api.hook";
import { useAppContext } from "../../context/app-context";
import LoadingScreen from "../../components/loader/loading-screen";
import "../../components/header/header.css";
import "./blog.css";

const BlogLayout = () => {
  const { getProxy, postProxy } = useAcubeService();
  const { slug, type } = useParams();
  const navigate = useNavigate();
  const [blogData, setBlogData] = useState(null);
  const [isViewed, setIsViewed] = useState(false);
  const { ipAddress } = useAppContext();
  const [error, setError] = useState(null);

  // Fetch blog details
  const fetchBlogData = useCallback(async () => {
    try {
      const result = await getProxy(`blog/details/${slug}`);
      const data = result.data?.length ? result.data[0] : result.data;
      setBlogData(data);
      return data;
    } catch (err) {
      console.error("Error fetching blog data:", err);
      setError("Failed to load blog. Please try again later.");
      return null;
    }
  }, [getProxy, slug]);

  // Increment views count
  useEffect(() => {
    fetchBlogData();
  }, []);

  if (error) {
    return <div className="blogs-section error">{error}</div>;
  }

  return (
    <div className="blogs-section position-relative">
      <Container fluid className="py-3 position-absolute top-0 start-0 end-0">
        <Row>
          <Col xs={12}>
            <Breadcrumb className="small mb-0">
              <Breadcrumb.Item
                onClick={() => navigate("/blogs")}
                className="cursor-pointer mb-0"
              >
                Blog Home
              </Breadcrumb.Item>

              {blogData ? (
                // 📝 On blog details page → Show blog title only
                <Breadcrumb.Item active className="mb-0">
                  {blogData.service_category}
                </Breadcrumb.Item>
              ) : (
                // 📂 On blog listing pages → Show type (Popular / Most Viewed / What's New)
                <Breadcrumb.Item active className="mb-0">
                  {type === "popular"
                    ? "Popular Posts"
                    : type === "most-viewed"
                      ? "Most Viewed"
                      : "What's New"}
                </Breadcrumb.Item>
              )}
            </Breadcrumb>

          </Col>
        </Row>
      </Container>

      {blogData ? (
        <>
          <div
            dangerouslySetInnerHTML={{
              __html:
                blogData?.page_content?.[0]?.html ||
                "<p>No content available.</p>",
            }}
          />
          {/* 🔙 Back to Blogs Link */}
          <Container className="text-center my-4">
            <Button
              variant="link"
              className="primary-text text-decoration-none"
              onClick={() => navigate("/blogs")}
            >
              ← Back to Blogs
            </Button>
          </Container>
        </>
      ) : (
        <LoadingScreen />
      )}
    </div>
  );
};

export default BlogLayout;
